import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import mainEn from "./localization/en/mainEn";
import mainHu from "./localization/hu/mainHu";
import mainCz from "./localization/cz/mainCz";
import mainSk from "./localization/sk/mainSk";
import mainDe from "./localization/de/mainDe";
import mainFr from "./localization/fr/mainFr";
import mainPl from "./localization/pl/mainPl";
import mainSi from "./localization/si/mainSi";
import mainHr from "./localization/hr/mainHr";
import mainRo from "./localization/ro/mainRo";

const resources = {
  en: {
    translation: mainEn
  },
  hu: {
    translation: mainHu
  },
  cz: {
    translation: mainCz
  },
  sk: {
    translation: mainSk
  },
  de: {
    translation: mainDe
  },
  fr: {
    translation: mainFr
  },
  pl: {
    translation: mainPl
  },
  si: {
    translation: mainSi
  },
  hr: {
    translation: mainHr
  },
  ro: {
    translation: mainRo
  },
  fallbackLang: {
    "hu": ["en"]
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;